import type { HTMLAttributes } from "react"

import { cn } from "@/lib/utils"

export default function InputError({
  messages,
  className = "",
  ...props
}: HTMLAttributes<HTMLParagraphElement> & { messages?: string[] }) {
  return messages ? (
    <p
      {...props}
      className={cn("text-hpi-red dark:text-hpi-light-red text-sm", className)}
    >
      {messages.join(", ")}
    </p>
  ) : null
}
